import type { DfyOrderStatus } from "@repo/api/dfy";
import ImageBadge from "@/lib/components/ImageBadge";
import { Dot } from "@/lib/components/Badge";

const statusStyles: Record<
  DfyOrderStatus,
  { label: string; dot: string; background: string }
> = {
  DRAFT: {
    label: "Draft",
    dot: "bg-grey-400",
    background: "border-grey-400/5 bg-grey-400/5",
  },
  SUBMITTED: {
    label: "Submitted",
    dot: "bg-tertiary-400",
    background: "border-tertiary-400/5 bg-tertiary-400/5",
  },
  IN_PROGRESS: {
    label: "In progress",
    dot: "bg-primary-400",
    background: "border-primary-400/5 bg-primary-400/5",
  },
  DELIVERED: {
    label: "Delivered",
    dot: "bg-green-400",
    background: "border-green-400/5 bg-green-400/5",
  },
};

export function dfyStatusLabel(status: DfyOrderStatus): string {
  return statusStyles[status].label;
}

export function DfyOrderStatusDot({ status }: { status: DfyOrderStatus }) {
  return <Dot aria-hidden="true" className={statusStyles[status].dot} />;
}

export default function DfyOrderStatusBadge({
  status,
  variant = "default",
}: {
  status: DfyOrderStatus;
  variant?: "default" | "image";
}) {
  const style = statusStyles[status];
  const content = (
    <>
      <DfyOrderStatusDot status={status} />
      <span className="truncate">{style.label}</span>
    </>
  );

  if (variant === "image") {
    return (
      <ImageBadge className="absolute right-3 bottom-2.5 flex max-w-[calc(100%-6rem)] items-center gap-2 rounded-sm bg-black/60 px-2 py-0.5">
        {content}
      </ImageBadge>
    );
  }

  return (
    <span
      className={`inline-flex shrink-0 items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium text-text-secondary ${style.background}`}
    >
      {content}
    </span>
  );
}
